/**
 * SubscriptionPlans - self-service paid plans suspended (21/10/2026).
 * The previous plans page (Basic/TOP) is in git history; the generator stays online as a showcase.
 */

import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';

interface SubscriptionPlansProps {
  onBack: () => void;
  onShowContact?: () => void;
}

const SubscriptionPlans: React.FC<SubscriptionPlansProps> = ({ onBack, onShowContact }) => (
  <Container maxWidth="sm" sx={{ py: 8 }}>
    <Paper sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>Paid plans are currently unavailable</Typography>
      <Typography color="text.secondary" paragraph>
        We are not selling self-service plans at the moment. You can still explore the platform.
        For information, please get in touch.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="outlined" onClick={onBack}>Back</Button>
        {onShowContact && <Button variant="contained" onClick={onShowContact}>Contact us</Button>}
      </Box>
    </Paper>
  </Container>
);

export default SubscriptionPlans;
